<script>
import { mapGetters } from 'vuex'
import CardInput from '../lightbox/card-enrollment/sub-pages/card-input.vue'
import SecurityInformation from '../lightbox/card-enrollment/sub-pages/security-information.vue'
import Authentication from '../authentication/authentication.vue'
import sharedService from '../../utils/shared-service'
import checkout from '../../utils/checkout'
import { AUTH_METHODS, AUTH_URI_DATA, SCOF_AUTH_NTS } from '../../utils/constant'
import authSDK from '../../orchestration/authSDK/index'
import requestBody from '../../orchestration/authSDK/request-parameter'
import traceService from '../shared/trace/trace-service'
import toasterService from '../../utils/toaster'

export default {
  name: 'PayByCard',
  components: {
    CardInput,
    SecurityInformation,
    Authentication
  },
  props: {
    showEnroll: {
      type: Boolean,
      value: false
    }
  },
  data () {
    return {
      error: '',
      reloadCard: 1,
      reloadInfo: 2,
      enableCardDetail: true,
      enrollCardData: {},
      selectedMethod: '',
      isExistingCard: false,
      authReason: '',
      autPopupCloseTimer: ''
    }
  },
  computed: {
    ...mapGetters([
      'dpaIds',
      'apiEndpoints',
      'enableAuthSDKFlow',
      'authExecutionFlow',
      'checkoutProgress',
      'authPresentationStyle',
      'enableB2bAuthLookupFIDO',
      'consumerJwt',
      'authResponse',
      'isNTSFlowEnabled',
      'enableNativeIntegrationFlow'
    ]),
    enableEnrollButton: function () {
      return this.showEnroll
    },
    b2bAuthLookupReason: {
      get () {
        return this.$store.state.configuration.auth.b2bAuthLookupReason
      }
    }
  },
  mounted () {
    let cofDpaids = this.dpaIds.filter((dpa) => {
      return dpa['displayDpaName'].includes('COF')
    })
    this.dpaId = cofDpaids[0]

    sharedService.clearStore()
  },
  methods: {

    async continuePayByCard () {
      this.$store.commit('setSelectedSavedCardDetails', null)
      this.$store.commit('setSelectedBindingDetails', null)
      this.$store.commit('setTraceId', null)
      try {
        this.error = ''
        let cardDetails = this.getCardDetails()
        let cardValidCheck = sharedService.validateCardDetails(cardDetails)
        if (cardValidCheck && this.$store.getters.consumerJwt) {
          let srcNetwork = cardDetails.network.toUpperCase()
          traceService.setNewTransaction()
          let srcNetworkKeys = this.$store.getters.srcKeys[srcNetwork].keys
          let encKeyId = this.apiEndpoints[srcNetwork].CARD_ENCKEY_KID
          let encryptedCard = await sharedService.encryptCard(cardDetails, encKeyId, srcNetworkKeys, true)
          this.enrollCard(encryptedCard, srcNetwork, cardDetails)
        } else {
          this.error = !cardValidCheck
            ? 'CARD_DETAIL_INVALID'
            : 'SIGN_IN_ACCOUNT'
        }
      } catch (error) {
        console.log('[START] ' + error)
        this.error = 'ENCRYPTION_FAILED'
      }
    },

    async enrollCard (encryptedCard, srcNetwork, cardDetails) {
      this.$store.commit('loaderOn', true)
      this.$store.commit('srcNetwork', srcNetwork)
      const srcCorrelationId = sharedService.generateUUID()
      let response = await checkout
        .callEnroll(
          srcCorrelationId,
          null,
          encryptedCard,
          this.dpaId.dpa[0].dpaId,
          srcNetwork
        )
        .catch((err) => {
          this.error = err
        })

      if (response) {
        let enrollResponse = response.enrollCardResponse
        try {
          let traceIdKey = Object.keys(response.headers).find(
            key => key.toLowerCase() === 'x-src-cx-flow-id'
          )
          let traceId = traceIdKey ? response.headers[traceIdKey][0] : null
          this.$store.commit('setTraceId', traceId)
        } catch (error) {
          this.error = error
        }

        let digitalCardData = enrollResponse.maskedCard.digitalCardData
        let authenticationMethods = digitalCardData.authenticationMethods ? digitalCardData.authenticationMethods : []
        let { srcCorrelationId } = response.enrollCardResponse
        let { srcDigitalCardId, serviceId } = enrollResponse.maskedCard

        if (this.isNTSFlowEnabled !== true) {
          let authSDKResponse = await this.authenticationMethodsLookupSDK(srcDigitalCardId, srcCorrelationId, serviceId)
          authenticationMethods = authSDKResponse ? authSDKResponse.authenticationMethods : []
        }
        authenticationMethods = await this.getAuthMethodsFromB2bCall(authenticationMethods, srcDigitalCardId, srcCorrelationId)

        if (authenticationMethods.length > 0) {
          this.enrollCardData = response
          this.enrollCardData.authenticationMethods = authenticationMethods
          this.enrollCardData.cardDetails = cardDetails
          let enrollResponse = response.enrollCardResponse.maskedCard
          enrollResponse.srcCorrelationId = srcCorrelationId
          this.$store.commit('setEnrollMaskCard', enrollResponse)
          this.enableCardDetail = false
          this.$store.commit('loaderOn', false)
        } else {
          this.$store.commit('loaderOn', false)
          toasterService.onFailure(this.$t('errorMessages.NO_AUTH_METHODS'))
        }
      }
    },

    async getAuthMethodsFromB2bCall (authenticationMethods, srcDigitalCardId, srcCorrelationId) {
      if (authenticationMethods.length === 0 || this.enableB2bAuthLookupFIDO) {
        let authB2BResponse = await this.authenticateMethodsLookupB2B(srcDigitalCardId, srcCorrelationId)
        authenticationMethods = authB2BResponse ? authB2BResponse.authenticationMethods : []
      }
      return authenticationMethods
    },

    async authenticationMethodsLookupSDK (srcDigitalCardId, srcCorrelationId, serviceId) {
      let response = await authSDK.callAuthSDKMethod(
        AUTH_METHODS.LOOKUP,
        requestBody[AUTH_METHODS.LOOKUP](srcDigitalCardId, srcCorrelationId, serviceId, 'ENROL_FINANCIAL_INSTRUMENT')
      )
        .catch((err) => {
          console.log(err)
          this.error = this.$t('LOOKUP_FAILED')
        })
      return response
    },

    async authenticateMethodsLookupB2B (srcDigitalCardId, srcCorrelationId) {
      const selectedb2bAuthLookupReasons = Object.keys(this.b2bAuthLookupReason)
        .filter((lookupReason) => {
          if (this.b2bAuthLookupReason[lookupReason]) {
            return lookupReason
          }
        })
      const network = 'mastercard'
      let reqParams = requestBody[AUTH_METHODS.B2BAUTHLOOKUP](
        this.enableB2bAuthLookupFIDO ? selectedb2bAuthLookupReasons[0] : 'ENROL_FINANCIAL_INSTRUMENT',
        srcCorrelationId,
        srcDigitalCardId
      )

      if (this.isNTSFlowEnabled && sharedService.checkFeatureFlag('START_NTS_CHANGES') && this.enableNativeIntegrationFlow) {
        reqParams['flowType'] = SCOF_AUTH_NTS
      }

      try {
        let response = await sharedService.getB2BAuthLookupApiResponse(reqParams)
        traceService.updateCallTraces(network, response.callTraces, true)
        return response.b2BLookupAuthenticationResponse
      } catch (err) {
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(network, errorLog, false)
      }
    },

    async initiateFlow (authenticationMethod, authenticationReason, isRecognized, savedCardDetails = null) {
      this.selectedMethod = authenticationMethod.authenticationMethodType
      this.authReason = authenticationReason
      let srcCorrelationId, srcDigitalCardId, serviceId
      if (isRecognized) {
        srcCorrelationId = savedCardDetails.srcCorrelationId
        srcDigitalCardId = savedCardDetails.maskedCard.srcDigitalCardId
        serviceId = savedCardDetails.maskedCard.serviceId
        this.isExistingCard = true
      } else {
        srcDigitalCardId = this.enrollCardData.enrollCardResponse.maskedCard.srcDigitalCardId
        serviceId = this.enrollCardData.enrollCardResponse.maskedCard.serviceId
        srcCorrelationId = this.enrollCardData.enrollCardResponse.srcCorrelationId
      }

      this.initiateAuthenticateMethod(authenticationMethod, authenticationReason, srcCorrelationId, srcDigitalCardId, serviceId)
    },

    async initiateAuthenticateMethod (authenticationMethods, authenticationReason, srcCorrelationId, srcDigitalCardId, serviceId) {
      let authenticateReq = requestBody[AUTH_METHODS.AUTHENTICATE](
        authenticationMethods,
        authenticationReason,
        srcCorrelationId,
        srcDigitalCardId,
        serviceId
      )

      let uriData = authenticationMethods.uriData ? authenticationMethods.uriData.uri : AUTH_URI_DATA.URI
      if (this.authExecutionFlow === 'CALLBACK_URL_FLOW') {
        try {
          traceService.addRequestLogs({
            methodName: AUTH_METHODS.AUTHENTICATE,
            params: authenticateReq
          })
          const result = await this.callPostMessage(authenticateReq, uriData)
          traceService.addResponseLogs(AUTH_METHODS.AUTHENTICATE, result)
          this.validateSwitchCase(result)
        } catch (error) {
          traceService.addResponseLogs(AUTH_METHODS.AUTHENTICATE, error)
          console.log('Error response: ', error)
          toasterService.onFailure(error.reason)
          this.closeIframeWindow()
        }
      } else {
        try {
          this.$refs.iframe.addEventListener('load', () => {
            this.$refs.iframeContainer.classList.add('show')
          })
          window.authIframe = this.$refs.iframe.contentWindow
          const response = await authSDK
            .callAuthSDKMethod(AUTH_METHODS.AUTHENTICATE, authenticateReq)
          console.log('Success response: ', response)
          this.validateSwitchCase(response)
        } catch (err) {
          console.log(err)
          this.error = this.$t('AUTHENTICATION_FAILED')
          toasterService.onFailure(err.reason)
          this.closeIframeWindow()
        }
      }
    },

    getCardDetails () {
      return {
        primaryAccountNumber: sharedService.unmask(
          this.$refs.cardNumber.cardNumber
        ),
        panExpirationMonth: this.$refs.securityInfo.expiry.split('/')[0],
        panExpirationYear: `${new Date()
          .getFullYear()
          .toString()
          .substr(0, 2)}${this.$refs.securityInfo.expiry.split('/')[1]}`,
        cardSecurityCode: this.$refs.securityInfo.cvc2,
        network: this.$refs.cardNumber.cardType
      }
    },

    reloadComponent () {
      this.$store.commit('loaderOn', false)
      this.$store.commit('resetLightbox')
      this.$store.commit('checkoutProgress', false)
    },

    closeIframeWindow () {
      this.reloadComponent()
      window.authIframe && window.authIframe.close()
      if (window.authSdkWindow) {
        window.authSdkWindow.close()
      }
    },

    async callPostMessage (payload, uriData) {
      if (this.isValidUrl(window.location.origin) && this.isValidUrl(uriData)) {
        this.$store.commit('checkoutProgress', true)
        this.$store.commit('loaderOn', true)

        return new Promise((resolve, reject) => {
          const url = `${new URL(uriData)}?origin=${encodeURIComponent(new URL(window.location.origin).origin)}`
          const windowRef = this.getWindowRef()
          if (windowRef && typeof windowRef.location === 'object') {
            windowRef.location.assign(url)
          } else {
            console.error('Invalid window reference.')
          }
          window.addEventListener('message', ({ data, source, origin }) => {
            if (source !== windowRef) return
            console.log('data::', data)
            switch (data.action) {
              case 'Ready':
                return windowRef.postMessage({
                  action: 'Authenticate',
                  payload
                }, origin)
              case 'Success':
                return resolve(data.payload)
              case 'Error':
                return reject(data.payload)
            }
          })
        })
      }
    },

    isValidUrl (url) {
      try {
        const parsedUrl = new URL(url)
        if (process.env.NODE_ENV === 'development') {
          return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:'
        } else {
          return parsedUrl.protocol === 'https:'
        }
      } catch (error) {
        console.error('Invalid URL detected.')
        return false
      }
    },

    getWindowRef () {
      if (this.authPresentationStyle === 'POPUP_BASED') {
        const { width, height } = sharedService.getResolution()
        window.authIframe && window.authIframe.close()
        let authPopup = window.open('', '_blank', 'popup')
        let left = (screen.width - width) / 2
        let top = (screen.height - height) / 2
        if (left <= 0 || top <= 0) {
          left = 600
          top = 200
        }
        authPopup.moveTo(left, top)
        authPopup.resizeTo(width, height)
        window.authSdkWindow = authPopup
        setTimeout(() => {
          window.document.getElementById('iframeContainer').classList.remove('show')
        }, 0)
        return window.authSdkWindow
      } else {
        return window.authIframe
      }
    },

    async validateSwitchCase (response) {
      switch (response.authenticationStatus) {
        case 'COMPLETE':
          this.reloadComponent()
          window.authIframe && window.authIframe.close()
          if (window.authSdkWindow) {
            window.authSdkWindow.close()
          }
          toasterService.onSuccess(this.$t('successMessages.AUTHENTICATION_SUCCESS'))
          let authResponse = {
            response,
            isExistingCard: this.isExistingCard,
            selectedMethod: this.selectedMethod,
            authReason: this.authReason
          }
          this.$store.commit('setAuthResponse', authResponse)
          this.$store.commit('setConsumerContactInfo', '')
          if (this.isExistingCard) this.$store.commit('setIsIABFlow', false)
          this.$router.push('/authreview').catch(err => { console.error(err) })
          break
        case 'CANCELLED':
          this.reloadComponent()
          window.authIframe && window.authIframe.close()
          if (window.authSdkWindow) {
            window.authSdkWindow.close()
          }
          break
        default:
          this.reloadComponent()
          toasterService.onFailure(this.$t('errorMessages.AUTHENTICATE_FAILED'))
          window.authIframe && window.authIframe.close()
          if (window.authSdkWindow) {
            window.authSdkWindow.close()
          }
      }
    }
  }
}

</script>
<template>
  <div class="mb-4">
    <div
      id="iframeContainer"
      ref="iframeContainer"
      :class="[
        checkoutProgress ? 'show' : '',
      ]"
      class="iframe-container slide-in">
      <div class="iframe-foreground">
        <iframe
          id="checkoutIframe"
          ref="iframe"
          class="iframe-checkout"
          name="checkout-iframe" />
      </div>
      <div
        id="iframeBackground"
        ref="iframeBackground"
        class="iframe-background" />
    </div>
    <div
      v-if="enableCardDetail"
      :class="{ 'card-input-wrapper': isNTSFlowEnabled, 'pl-4 card-input-wrapper': !isNTSFlowEnabled }">
      <div
        v-if="error"
        class="alert alert-danger"
        role="alert">
        {{ $t("errorMessages." + error) }}
      </div>
      <h4
        v-if="isNTSFlowEnabled"
        class="mb-6" >Add card</h4>
      <card-input
        ref="cardNumber"
        :key="reloadCard" />
      <security-information
        ref="securityInfo"
        :key="reloadInfo" />

      <button
        v-if="enableEnrollButton"
        id="enroll-button"
        :disabled="!enableAuthSDKFlow"
        class="btn btn-primary btn-lg mt-3 px-5"
        data-test="btn-continue"
        type="submit"
        @click="continuePayByCard()"
      >
        {{ $t("label.continueLabel") }}
      </button>
    </div>
    <div v-else>
      <authentication
        ref="authComponent"
        :enroll-mask-card-data="enrollCardData"
        :is-returning-user="isExistingCard"
        @initiate="initiateFlow"
      />
    </div>
  </div>
</template>
